export const SpinningLoaderSizes = Object.freeze({
  Small: "sm",
  Medium: "md",
  Large: "lg",
} as const);

export type SpinningLoaderSize =
  (typeof SpinningLoaderSizes)[keyof typeof SpinningLoaderSizes];

export const SpinningLoaderSizeOptions: SpinningLoaderSize[] =
  Object.values(SpinningLoaderSizes);
